import { render, staticRenderFns } from "./city2.vue?vue&type=template&id=48533b08&scoped=true&"
import script from "./city2.vue?vue&type=script&lang=js&"
export * from "./city2.vue?vue&type=script&lang=js&"
import style0 from "./city2.vue?vue&type=style&index=0&id=48533b08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48533b08",
  null
  
)

export default component.exports